import { ACCOUNT_REQUEST, ACCOUNT_SUCCESS, ACCOUNT_FAILURE, ACCOUNT_RESET} from '../actions/auth';

const initialState = {
    state: 'idle',
};

export default function auth(state = initialState, action: any) {
    switch (action.type) {
        case ACCOUNT_REQUEST:
            return {
                ...state,
                state: 'loading',
            };
        case ACCOUNT_SUCCESS:
            return {
                ...state,
                ...action.payload,
                state: 'success',
            };
        case ACCOUNT_FAILURE:
            return {
                ...state,
                state: 'failure',
            };
        case ACCOUNT_RESET:
     return initialState;
        default:
            return state;
    }
}


